import script from "./BlockAdmission.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockAdmission.vue?vue&type=script&setup=true&lang=js"

import "./BlockAdmission.vue?vue&type=style&index=0&id=20d8d612&lang=scss"

const __exports__ = script;

export default __exports__